import { render } from "./FarmOS.vue?vue&type=template&id=2f350cb4&scoped=true"
import script from "./FarmOS.vue?vue&type=script&lang=js"
export * from "./FarmOS.vue?vue&type=script&lang=js"

import "./FarmOS.vue?vue&type=style&index=0&id=2f350cb4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f350cb4"]])

export default __exports__